import React from 'react';
import { compose } from 'redux';
import { useQuery } from '@apollo/client';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import withLayout from '../../../core/components/with-layout';

import CompletedTestsSegment from '../../../core/components/completed-tests-segment';
import Tabs from '../../constants/tabs';
import { COMPLETED_TEST_SESSIONS_BY_USER } from '../../../core/graphql/test-sessions';

import {
  Container,
  Title,
  Text,
  SegmentTable,
} from './styles';

const CompletedTests = (props) => {
  const {
    userId,
  } = props;

  const {
    data = {},
  } = useQuery(COMPLETED_TEST_SESSIONS_BY_USER, {
    variables: {
      userId,
      isCompleted: true,
      order: 'completed_at DESC',
      hidden: false,
    },
  });

  const {
    testSessions = [],
  } = data;

  return (
    <Container>
      <Title>Completed Tests</Title>

      <Text>
        You will be paid for completed tests within 8 days.
      </Text>

      <SegmentTable>
        <CompletedTestsSegment
          testSessions={testSessions}
        />
      </SegmentTable>

    </Container>
  );
};

CompletedTests.propTypes = {
  userId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  userId: authentication.profile.user_id || '',
});

export default compose(
  withLayout({ selectedTab: Tabs.COMPLETED_TESTS }),
  connect(mapStateToProps, null),
)(CompletedTests);
